// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Orm8","paramInput":"JobSimulator_paramInput__1vK_o","input":"JobSimulator_input___h0wQ"};